import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import CustomTableBack from '../../../common/CustomTableBack';
import IncomeHeader from '../../../Reports/IncomeReport/IncomeHeader';
import { currencyFormatter } from '../../../../helpers/Functions';
import strings from '../../../../localization';

import styles from './styles';

interface IOwnershipBookingsHeader {
  totalPaid: number;
  totalCharged: number;
}

const OwnershipBookingsHeader: FC<IOwnershipBookingsHeader> = ({
  totalPaid,
  totalCharged,
}) => {
  const summary = [
    {
      key: 0,
      label: strings.totalPaid,
      amount: currencyFormatter(totalPaid),
    },
    {
      key: 1,
      label: strings.totalCharged,
      amount: currencyFormatter(totalCharged),
    },
  ];

  return (
    <Box>
      <Box sx={styles.headerContainer}>
        <CustomTableBack backLabel={strings.backToOwnershipReport} />
        <Typography sx={styles.titleFont}>{strings.bookings}</Typography>
      </Box>
      <IncomeHeader summary={summary} />
    </Box>
  );
};

export default OwnershipBookingsHeader;
